import { Injectable } from '@angular/core';
import { ApiService } from '@app/core/services';
import { User, UserCollection } from '@app/core/interfaces';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService extends ApiService {

  public get(id: string | number, filters: { [x: string]: any } = {}): Observable<User> {
    const queryString = this.convertObjectToQueryString(filters) 
    return this.http.get<User>(`${this.apiUrl}/users/${id}${queryString}`)
  }

  public getCollection(filters: { [x: string]: any } = {}): Observable<UserCollection> {
    const queryString = this.convertObjectToQueryString(filters) 
    return this.http.get<UserCollection>(`${this.apiUrl}/users/${queryString}`)
  }

  public post(data: Partial<User>): Observable<User> {
    return this.http.post<User>(`${this.apiUrl}/users/`, data)
  }

  public patch(id: string | number, data: Partial<User>): Observable<User> {
    return this.http.patch<User>(`${this.apiUrl}/users/${id}`, data)
  }

  public delete(id: string | number): Observable<string> {
    return this.http.delete<string>(`${this.apiUrl}/users/${id}`)
  }
  
  public register(data: Partial<User>): Observable<User> {
    return this.http.post<User>(`${this.apiUrl}/auth/register`, data)
  }
}
